module.exports = __webpack_public_path__ + "img/Freesia.351ec88f.jpg";